import { Component, ViewChild, Input, Output, OnChanges, EventEmitter  } from '@angular/core';
import { TranslateService, TranslatePipe, LangChangeEvent } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../../common/global-variables';
import { IpValidationUtils  } from '../../../../../../common/validations/ip-validation-utils';
let $ = require('jquery');
const _ = require('lodash');
import { AppState } from '../../../../../app.service';
import { NgForm } from '@angular/forms';
import { Service } from '../org-vdc-wizard.service';
import { ArrayUtils } from '../../../../../../common/utils/array-utils';
import { VcaAlertsService } from '../../../../../../common/vca-alerts/vca-alerts.service';

@Component({
  selector: 'edit-storage-policy-dialog',
  styles: [require('../org-vdc.wizard.scss')],
  template: require('./edit-sp.html'),
   providers: [
    TranslateService, Service
  ]
})

export class EditStoragePolicyDialog {
    @Input() orgVdcId: string = '';
    @Input() isDialogOpen: boolean = false;
    @Output('onClose') selfClose = new EventEmitter();

    private showGuaranteeFields: boolean = false;
    private editData: any;
    private subscribeHandler;
    private isValid: boolean = true;
    private crudResult: any;
    private selectedStorageProfiles: any;
    private loading: boolean = false;
    private pVDCList: any;
    private pVDCSelected: any;
    private isGetEditDataCompleted: boolean = false;
    private pVDCDisplay: any;
    private isPVDCLoaded: boolean = false;
    private isPageLoading: boolean = false;
    private sddcStepData = {
         selectedSDDC: [],
         pVDC: [],
    };

    private dataModel = {
        orgName: '',
        selectedOrgId: '',
        name: '',
        description: '',
        pVdc: {
        name: '',
        cpu: 0,
        memory: 0,
        storage: 0,
        iopsEnabled: false
        },
        allocModel: '',
        cpu: 0,
        memory: 0,
        cpuGuarantee: 0,
        memoryGuarantee: 0,
        storage: 0
    };
    private isIpRangeValid: false;

    constructor(public service: Service, private translate: TranslateService, private alert: VcaAlertsService) {
        translate.use(GlobalVariables.LOCALE);
    }

    ngOnChanges(changes) {
        if (!this.isDialogOpen) {
            this.resetForm();
            this.editData = null;
        }
        if (this.orgVdcId && this.isDialogOpen) {
            this.getEditData();
            this.getPVdcs();
        }
    }

    resetForm() {
        this.dataModel = {
            orgName: '',
            selectedOrgId: '',
            name: '',
            description: '',
            pVdc: {
                name: '',
                cpu: 0,
                memory: 0,
                storage: 0,
                iopsEnabled: false
            },
            allocModel: '',
            cpu: 0,
            memory: 0,
            cpuGuarantee: 0,
            memoryGuarantee: 0,
            storage: 0
        };
        this.isValid = true;
        this.loading = false;
    }

    setDataModel() {
        let data = this.editData;
        this.dataModel.orgName = (data.orgName) ? data.orgName : '';
        this.dataModel.name = (data.name) ? data.name : '';
        this.dataModel.description = (data.description) ? data.description : '';

        let pVdc: any;

        if (data.providerVDC && data.providerVDC.vcd) {
        let storageTotal = 0;
        pVdc = data.providerVDC.vcd;
        this.dataModel.pVdc.name = (pVdc.name) ? pVdc.name : '';
        this.dataModel.pVdc.cpu = pVdc.computeCapacity.cpu.total;
        this.dataModel.pVdc.memory = pVdc.computeCapacity.memory.total;

        for (let j = 0; j < pVdc.storageProfiles.length; j++) {
            storageTotal += pVdc.storageProfiles[j].capacityTotal;
        }
        this.dataModel.pVdc.storage = storageTotal;
        this.dataModel.pVdc.iopsEnabled = (pVdc.iopsEnabled) ? pVdc.iopsEnabled : false;
        }

        this.dataModel.allocModel = data.allocationModel;
        if (data.computeCapacity) {
        let compCap = data.computeCapacity;
        if (this.dataModel.allocModel === 'RESERVATIONPOOL') {
                this.dataModel.cpu = (compCap.cpu) ? compCap.cpu.limit / 1000 : 0;
                this.dataModel.memory = (compCap.memory) ? compCap.memory.limit / 1024 : 0;
            } else {
                this.dataModel.cpu = (compCap.cpu) ? compCap.cpu.allocated / 1000 : 0;
                this.dataModel.memory = (compCap.memory) ? compCap.memory.allocated / 1024 : 0;

                this.dataModel.cpuGuarantee = (data.resourceGuaranteedCpu) ? data.resourceGuaranteedCpu * 100 : 0;
                this.dataModel.memoryGuarantee = (data.resourceGuaranteedMemory) ? this.editData.resourceGuaranteedMemory * 100 : 0;
                this.showGuaranteeFields = true;
                }
        }
        this.dataModel.storage = this.editData.storageCapacity.reserved / 1024;
    }

    getEditData() {
        this.isPageLoading = true;
        this.subscribeHandler = this.service.getVirtualdc(this.orgVdcId)
        .subscribe(
            editData => {
            this.editData = editData;
            this.setDataModel();
            this.filterPVDC();
            this.isPageLoading = false;
            },
            error => {
                this.service.logError(error, 'get Edit data error')
            },
            () => {
                 this.service.logOperationCompleted('get Edit data Completed')
            }
        );
    }

    getPVdcs() {
        this.subscribeHandler = this.service.getPVdcs()
        .subscribe(
            (result: any) => {
                this.pVDCList = result;
                this.sddcStepData.pVDC = result;
                this.filterPVDC();
            },
            error => this.service.logError(error, 'get SDDC Pool'),
            () => this.service.logOperationCompleted('get SDDC Pool completed')
        );
    }

    filterPVDC() {
        if (!this.pVDCList || !this.editData) {
            return;
        }
        let objectId = (ArrayUtils.isPropertyExist(this.editData, 'providerVDC.vcd.objectId')) ? this.editData.providerVDC.vcd.objectId : '';
        this.pVDCSelected = _.find(this.pVDCList, 'objectId', objectId);
        this.sddcStepData.selectedSDDC.push(this.pVDCSelected);
        this.processPVDC();
    }

    processPVDC() {
        if (!this.pVDCSelected) {
            return;
        }

        let data = this.pVDCSelected;
        let storageTotal = 0;
        let storageUnits = [];
        for (let j = 0; j < data.storageProfiles.length; j++) {
            let sp = data.storageProfiles[j];
            if (sp.units && sp.capacityTotal) {
            storageTotal +=  (sp.units === "MB") ? sp.capacityTotal / 1024 : sp.capacityTotal;
            }
        }

        let cpu = (data.cpu && data.cpu.total) ? data.cpu.total : '-';
        if (cpu !== '-' && data.cpu.units === "MHz") {
            cpu /= 1024;
        }

        let memory = (data.memory && data.memory.total) ? data.memory.total : '-';
        if (memory !== '-' && data.memory.units === "MB") {
                memory /= 1024;
        }

        this.pVDCDisplay = {
            name: (data.name) ? data.name : '-' ,
            cpu: (cpu !== '-') ? cpu.toFixed(2) : '-',
            memory: (memory !== '-') ? memory.toFixed(2) : '-',
            storageTotal: storageTotal.toFixed(2),
            iopsEnabled: (data.iopsEnabled) ? data.iopsEnabled : 'false',
            isReady: true
        }
        this.isPVDCLoaded = true;
  }

    postData() {
        this.loading = true;
        this.isValid = false;
        let storageProfiles = this.getAllocatedStorageProfilesForEdit();
        this.subscribeHandler = this.service.editStorageProfiles(this.orgVdcId, storageProfiles)
            .subscribe(
                (crudResult: any) => {
                        this.isValid = true;
                        this.loading = false;
                    if (crudResult && crudResult.error) {
                        this.alert.danger([crudResult.errorMessage], 'edit-sp-dialog');
                    } else {
                        this.crudResult = crudResult;
                        this.closeSelf();
                    }
                },
                error => {
                      this.isValid = true;
                      this.loading = false;
                      this.alert.danger(['Operation Failed. Please try again', error], 'edit-sp-dialog');
                },
                () => {
                    this.service.logOperationCompleted('Edit OrgVdc Completed')
                }
            );
        }

    onSubmitButtonClicked(f: NgForm) {
        this.postData();
    }

    onCancelButtonClicked() {
        this.closeSelf();
    }


    ngOnDestroy() {
        if (this.subscribeHandler) this.subscribeHandler.unsubscribe();
    }

    closeSelf() {
        if (this.selfClose) {
            this.selfClose.emit({
                value: 'close'
            });
        }
    }

    getAllocModel() {
        if (this.dataModel.allocModel === 'RESERVATIONPOOL') {
            return this.translate.instant('createOrgVdc.allocModel.RESERVATIONPOOL');
        } else if (this.dataModel.allocModel === 'ALLOCATIONPOOL') {
            return this.translate.instant('createOrgVdc.allocModel.ALLOCATIONPOOL');
        }
    }

    updateStorageProfile(event) {
        if (event.isDelete && typeof event.showErrorMsg !== "undefined" && event.showErrorMsg) {
            this.isValid = false;
            this.alert.danger([this.translate.instant('createOrgVdc.wizard.noDefaultStorageProfile')], 'edit-sp-dialog');
            return;
        }
        this.selectedStorageProfiles = [];
        event.model.forEach(element => {
            if (!element.isDeleted) {
                this.selectedStorageProfiles.push (element);
            }
        });

        let spList = [];
        let isSPValid: boolean = true;
        let isDistinctSP: boolean = true;
        let isDefaultSelected: boolean = false;
        let len = this.selectedStorageProfiles.length;

        for (let i = 0; i < len; i++) {
            if (this.selectedStorageProfiles[i].default) {
                isDefaultSelected = true;
            }
            spList.push (this.selectedStorageProfiles[i].name.toLowerCase());
            if (!this.selectedStorageProfiles[i].isComponentValid) {
                isSPValid = false;
            }
            if ((i + 1) < len && spList.indexOf(this.selectedStorageProfiles[i + 1].name.toLowerCase()) >= 0) {
                isDistinctSP = false;
            }
        }
        this.isValid = (isSPValid && isDistinctSP && isDefaultSelected) ? true : false;
    }

    getStorageProfileDetails(selectedProfile) {
        let iopsEnabled = false;
        if (selectedProfile) {
            if (selectedProfile.hasOwnProperty('iopsEnabled')) {
                iopsEnabled = selectedProfile.iopsEnabled;
            } else if (selectedProfile.hasOwnProperty('iopsSettings')) {
                iopsEnabled = selectedProfile.iopsSettings.enabled;
            }
        }
        let checked =  $('#'+selectedProfile.radioId).is(':checked');
        return {
            objectId: selectedProfile.objectId,
            storage: selectedProfile.storage,
            iopsSettings : selectedProfile.iopsSettings,
            default: checked //selectedProfile.default
        };
    }

    getAllocatedStorageProfilesForEdit() {
        let existingVdcStorageProfiles = _.cloneDeep(this.editData.vdcStorageProfiles);
        let selectedStorageProfiles = _.cloneDeep(this.selectedStorageProfiles);

        let providerVDCStorageProfiles = _.cloneDeep(this.editData.providerVDC.vcd.storageProfiles.providerVdcStorageProfile);
        let deletedStorageProfiles = ArrayUtils.arrayDiffBy(existingVdcStorageProfiles, selectedStorageProfiles, 'objectId');
        let addedStorageProfiles = ArrayUtils.arrayDiffBy(selectedStorageProfiles, existingVdcStorageProfiles, 'objectId');
        let updatedStorageProfiles;

        if (addedStorageProfiles.length > 0) {
            updatedStorageProfiles = ArrayUtils.arrayDiffBy(selectedStorageProfiles, addedStorageProfiles, 'objectId');
        } else {
            updatedStorageProfiles = selectedStorageProfiles;
        }

        let deletedStorageProfileIds = [];

        for (let i = 0; i < deletedStorageProfiles.length; ++i) {
            deletedStorageProfileIds.push(deletedStorageProfiles[i]['objectId']);
        }
        let updatedStorageProfilesToBeSubmitted = [];
        let addedStorageProfilesToBeSubmitted = [];
        let noOfAcceptedProfiles = 0;

        for (let i = 0; i < selectedStorageProfiles.length; ++i) {
            let storageProfileDetails = this.getStorageProfileDetails(selectedStorageProfiles[i]);
            let storageDemanded = storageProfileDetails.storage ? Number(storageProfileDetails.storage) * 1024 : storageProfileDetails.storage;
            if (storageDemanded > 0) {
                if (ArrayUtils.doesArrayContainsValue(addedStorageProfiles, 'objectId', storageProfileDetails.objectId)) {
                    addedStorageProfilesToBeSubmitted.push({
                        pvdcStorageProfileId : storageProfileDetails.objectId,
                        limit: storageDemanded,
                        unit: 'MB',
                        iopsSettings : storageProfileDetails.iopsSettings,
                        default : storageProfileDetails.default
                    });
                } else {
                    updatedStorageProfilesToBeSubmitted.push({
                        objectId : storageProfileDetails.objectId,
                        limit: storageDemanded,
                        unit: 'MB',
                        iopsSettings : storageProfileDetails.iopsSettings,
                        default : storageProfileDetails.default
                    });
                }
                noOfAcceptedProfiles++;
            }
        }
        let editStorage = {
            deleteStorageProfiles: deletedStorageProfileIds,
            updateStorageProfiles: updatedStorageProfilesToBeSubmitted,
            addStorageProfiles:  addedStorageProfilesToBeSubmitted
        };
        return editStorage;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/compute/compute-vcd/org-vdc-wizard/dialog/edit-sp-component.ts